<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import { ProductMovementsRepository } from '../../modules/posApi/stock/product-movements/product-movements.repository'
    import { ProductMovementsService } from '../../modules/posApi/stock/product-movements/product-movements.service'
    import { ProductMovementReasonEnum } from '../../modules/posApi/stock/product-movements/product-movement-reason.enum'
    import type { ProductMovement } from '../../modules/posApi/stock/product-movements/product-movement'
    import type { Service } from '../../modules/posApi/services/service'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import Zframe from '../_common/z/zframe.svelte'

    const dispatch = createEventDispatcher()

    const rep = new ProductMovementsRepository()
    const service = new ProductMovementsService(rep)

    export let entity: Service = null

    let show = false
    let newQuantity: number = entity?.stock || 0

    $: delta = (newQuantity ?? 0) - (entity?.stock || 0)

    async function saveEntity() {
        try {
            if (show) return
            if (newQuantity === null || newQuantity === undefined) {
                window.error('Informe a nova quantidade')
                return
            }
            if (delta === 0) {
                window.error('A nova quantidade é igual à atual — nada a ajustar')
                return
            }
            show = true
            const dto: Partial<ProductMovement> = {
                serviceId: entity.serviceId,
                type: delta > 0 ? 'in' : 'out_manual',
                quantity: Math.abs(delta),
                value: 0,
                movedAt: new Date(),
                reason: ProductMovementReasonEnum.ajuste_inventario,
                notes: 'Ajuste de balanço: ' + entity.stock + ' → ' + newQuantity,
            }
            await service.create(dto)
            window.api.users.statistics.tick('stock.movement')
            dispatch('change')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function cancelEntity() {
        dispatch('cancel')
    }
</script>

<div class="root">
    <Zact>
        <div class="spacer" />
        <Zbutton color="secondary" label="Cancelar" on:click={cancelEntity} />
        <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
    </Zact>
    <Zframe class="m-3">
        <ZContainer>
            <ZContainerCol size={12}>
                <div class="text-muted mb-2">
                    <b>{entity?.name}</b> — informe a quantidade contada fisicamente. O sistema lança automaticamente a entrada ou saída necessária pra corrigir
                    o estoque.
                </div>
            </ZContainerCol>
            <Zinput size={6} sizeM={12} type="number" label="Quantidade atual" value={entity?.stock} disabled={true} />
            <Zinput size={6} sizeM={12} type="number" label="Nova quantidade" bind:value={newQuantity} />
            {#if delta !== 0}
                <ZContainerCol size={12}>
                    <div class="alert {delta > 0 ? 'alert-success' : 'alert-warning'} mt-2">
                        {#if delta > 0}
                            Será lançada uma <b>entrada</b> de {delta} unidade(s).
                        {:else}
                            Será lançada uma <b>saída</b> de {Math.abs(delta)} unidade(s).
                        {/if}
                    </div>
                </ZContainerCol>
            {/if}
        </ZContainer>
    </Zframe>
</div>
